import { render, staticRenderFns } from "./picturecube.vue?vue&type=template&id=a484a444&scoped=true&"
import script from "./picturecube.vue?vue&type=script&lang=js&"
export * from "./picturecube.vue?vue&type=script&lang=js&"
import style0 from "./picturecube.vue?vue&type=style&index=0&id=a484a444&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a484a444",
  null
  
)

export default component.exports